import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import "./ServiceCard.css";

interface ServiceCardProps {
    link: string;
    icon: IconProp;
    title: string;
    description: string;
}
export const ServiceCard = (props: ServiceCardProps) => {
    return (
        <div className="service-card text-center">
            {props.link ? (
                <a href={props.link} className="link-style">
                    <div className="service-icon">
                        <FontAwesomeIcon icon={props.icon} size="3x" />
                    </div>
                    <div className="service-content">
                        <h3 style={{ fontSize: '1.2rem' }}>{props.title}</h3>
                        <p style={{ fontSize: '0.9rem' }}>{props.description}</p>
                    </div>
                </a>
            ) : (
                <div>
                    <div className="service-icon">
                        <FontAwesomeIcon icon={props.icon} size="3x" />
                    </div>
                    <div className="service-content">
                        <h3>{props.title}</h3>
                        <p>{props.description}</p>
                    </div>
                </div>
            )}
        </div>
    );
};